import React from 'react';
import { Tooltip } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Text } from '@/components/Typography';

export interface IconType {
	name: string;
	position: number;
	isComplete: boolean;
	currentStep: number;
	reachedStep?: number;
	isConsolidated?: boolean;
	onStepNagivationClick: (step: number) => Promise<void> | void;
}

export function StepIcon({
	currentStep,
	name,
	position,
	isComplete,
	reachedStep = currentStep,
	isConsolidated = false,
	onStepNagivationClick
}: Readonly<IconType>): JSX.Element {
	const bigName = name.length > 23 ? I18n.get(name) : undefined;

	if (currentStep === position) {
		return (
			<span className="step-name">
				<Tooltip title={bigName}>
					<Text ellipsis>{I18n.get(name)}</Text>
				</Tooltip>
			</span>
		);
	}

	function handleStepChange() {
		if (isConsolidated) {
			return;
		}

		if (position > reachedStep && !isComplete) {
			return;
		}

		onStepNagivationClick(position);
	}

	const disabled = !isConsolidated && (isComplete || position <= reachedStep) ? '' : 'disabled-step';

	return (
		<div className="step-hover">
			<button
				className={currentStep > position ? 'step-checked' : `step-number ${disabled}`}
				onClick={() => handleStepChange()}
			>
				{position + 1}
			</button>
			<button
				className={currentStep < position ? `step-number-hovered ${disabled}` : 'step-checked-hovered'}
				onClick={() => handleStepChange()}
			>
				<Tooltip title={bigName}>
					<Text ellipsis>{I18n.get(name)}</Text>
				</Tooltip>
			</button>
		</div>
	);
}
